<template>
  <div>
    <div id="productVariants" class="product-description">
      <h1>
        <span v-if="baseProductDetail.manufName">{{ $toTitleCase(title) }} - {{ baseProductDetail.manufName }}</span>
        <span v-else>{{ $toTitleCase(title) }}</span>
      </h1>
      <!-- New card -->
      <div
        class="grid grid-rows md:grid-cols-1 gap-4"
        v-if="baseProductDetail.products && baseProductDetail.products.length > 0"
      >
        <card
          v-for="item in baseProductDetail.products"
          :key="item.productId"
          class="border border-disabled-background h-full flex flex-col relative"
        >
          <template v-slot>
            <div class="absolute top-2 right-2" @click.prevent="favorite(item, baseProductDetail)">
              <component
                v-if="!isReplenishmentFlow"
                :is="item.isFavourite ? 'HeartSolidIcon' : 'HeartIcon'"
                class="h-5 w-5 text-primary-default cursor-pointer"
              />
            </div>
            <div class="flex flex-col md:flex-row flex-grow gap-2">
              <div class="flex-col">
                <div class="md:text-base text-xs text-tdefault-color font-bold mb-2 cursor-pointer overflow-hidden">
                  {{ $toTitleCase(item.title) }}
                </div>
                <div class="flex-row mb-2">
                  <span class="text-tdefault-color md:text-base text-xs mr-2">{{ item.productCode }}</span>
                  <span class="text-tdefault-color md:text-base text-xs pl-2 border-l border-stone-200">
                    {{ item.packagingUnit }} {{ item.packagingLabel }}
                  </span>
                </div>
                <div class="row">
                  <div class="mb-2">
                    <span
                      v-if="isCustomerFlow"
                      class="inline-flex gap-1 border-b border-dashed md:text-base text-xs"
                      :class="
                        item.isInsured
                          ? 'text-success-default border-success-default'
                          : 'text-danger-text border-danger-text'
                      "
                    >
                      <component
                        :is="item.isInsured ? 'CheckCircleIcon' : 'ExclamationCircleIcon'"
                        class="h-4 w-4 md:h-5 md:w-5"
                      />
                      {{ item.isInsured ? 'Vergoed' : 'Niet vergoed' }}
                    </span>
                  </div>
                  <div class="md:ml-5 mb-2">
                    <!-- <span
                    class="inline-flex gap-1 border-b border-dashed md:text-base text-xs"
                    :class="
                      item.orderable
                        ? 'text-success-default border-success-default'
                        : 'text-warning-default border-warning-default'
                    "
                  >
                    <component
                      :is="item.orderable ? 'CheckCircleIcon' : 'XCircleIcon'"
                      class="h-4 w-4 md:h-5 md:w-5"
                    />
                    {{ item.orderable ? 'Leverbaar' : 'Niet leverbaar' }}
                  </span> -->
                  </div>
                </div>
              </div>
              <div class="grid ml-auto mt-4 md:mt-0 content-center">
                <div
                  class="col mb-1"
                  v-if="
                    isProductDetailsPageFlow(item.isAlternativesBPIdAvailable) && !item.orderable && !isAssortmentFlow
                  "
                >
                  <button
                    class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-primary-default bg-cta rounded-full items-center mb-2 mr-2"
                    @click.prevent="goToAlternativesProductDetailsPage(item.alternativesBaseProductId)"
                  >
                    {{ getButtonText(item.productRelationType) }}
                  </button>
                </div>
                <button
                  v-else-if="item.orderable && !isAssortmentFlow"
                  class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-primary-default bg-cta rounded-full items-center mb-2 mr-2"
                  @click.prevent="order(item.productId, 1)"
                >
                  Bestellen
                </button>
                <div class="mb-2" v-else-if="String(item.MaterialStatusCode) === '30' && !isAssortmentFlow">
                  Op bestelling verkrijgbaar
                </div>
                <div class="mb-2" v-else-if="!item.orderable && !isAssortmentFlow">Niet bestelbaar</div>
              </div>
            </div>
          </template>
        </card>
      </div>

      <template v-if="baseProductDetail.products && baseProductDetail.products.length === 0">
        <v-warning-message
          :class="{ 'zoomOut animated': animated }"
          :warning="'Het is nog niet mogelijk om dit product te bestellen. Gelieve een ander product uit de catalogus te kiezen.'"
          :html="true"
          :is-urgent="false"
        />
      </template>
    </div>
    <div v-if="isPrompt" class="product-description__overlay_div">
      <div class="product-description__overlay_box">
        <h3 class="product-description__closeOverlay" @click="closeOverlay()">X</h3>
        <div class="product-description__v_overlay">
          <div class="row grid-margin">
            <div class="col product-description__overlay_title">Product valt niet binnen de machtiging(en).</div>
          </div>
          <div class="row grid-margin">
            <div class="col product-description__overlay_text">
              Zonder machtiging ontvangt de patiënt geen vergoeding van de zorgverzekeraar. Weet u zeker dat u wilt
              doorgaan?
            </div>
          </div>
          <div class="row grid-margin">
            <div class="col-xs-6">
              <v-button
                class="btn--hollow product-description__noBorder product-description__continue_button"
                @click.prevent="continueAddProduct"
              >
                Toch bestellen
              </v-button>
            </div>
            <div class="col-xs-2">&nbsp;</div>
            <div class="col-xs-4">
              <router-link to="/patientdashboard" class="btn btn--secondary product-description__dashboard_button">
                Machtiging aanmaken
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="product-description__invisible_div" @click="closeOverlay()" />
    </div>
    <v-overlay v-if="showProductFavourites">
      <v-product-favourites
        :base-product="selectedBaseProductForFavorite"
        :product="selectedProductForFavorite"
        :product-id="favProductId"
        @success="successSaveFavorite(...arguments)"
        @cancel="closeFavOverlay"
      />
    </v-overlay>
  </div>
</template>

<script>
import VProductVariants from './ProductVariants';
import VWarningMessage from '@/components/shared/WarningMessage';
import { HeartIcon as HeartSolidIcon } from '@heroicons/vue/20/solid';
import { CheckCircleIcon, ExclamationCircleIcon, XCircleIcon, HeartIcon } from '@heroicons/vue/24/outline';
import VHeartOutlineIcon from 'icons/HeartOutline';
import router from '@/router';
import { addToShoppingCart, shoppingCart$, activePpwRecId$ } from '@/services';
import { ref } from 'vue';
import { useStore } from 'vuex';
import VProductFavourites from './ProductFavourites';

export default {
  name: 'ProductDescription',
  components: {
    HeartIcon,
    VHeartOutlineIcon,
    VProductVariants,
    VWarningMessage,
    CheckCircleIcon,
    ExclamationCircleIcon,
    XCircleIcon,
    HeartSolidIcon,
    VProductFavourites
  },
  props: {
    title: String,
    productId: String,
    sapId: String,
    shortDescription: String,
    productUnit: String,
    baseProductDetail: Object
  },
  setup() {
    const store = useStore();
    const shoppingCart = ref(null);
    const activePpwRecId = ref(null);

    shoppingCart$.subscribe((value) => {
      shoppingCart.value = value;
    });

    activePpwRecId$.subscribe((value) => {
      activePpwRecId.value = value;
    });

    return {
      shoppingCart,
      activePpwRecId
    };
  },
  data() {
    return {
      isPrompt: false,
      currentOrderDetails: {},
      favoriteStatusEnum: {
        false: 'v-heart-outline-icon',
        true: 'v-heart-icon'
      },
      showProductFavourites: false,
      selectedBaseProductForFavorite: null,
      selectedProductForFavorite: null,
      favProductId: null
    };
  },
  computed: {
    isReplenishmentFlow() {
      return router.currentRoute.value.meta.flow === 'replenishment';
    },
    isAssortmentFlow() {
      return router.currentRoute.value.meta.flow === 'assortment';
    },
    isCustomerFlow() {
      return router.currentRoute.value.meta.flow === 'customer';
    },
    isProductDetailsPageFlow() {
      return (isAlternativesBPIdAvailable) => {
        return isAlternativesBPIdAvailable;
      };
    }
  },
  methods: {
    // Function to show an alert message
    showAlert(productId) {
      const orderedProduct = this.baseProductDetail.products.find((p) => p.productId === productId);

      if (orderedProduct) {
        this.$emitter.emit('notification', {
          title: `${orderedProduct.title} is toegevoegd.`,
          htmlMessage: `<p class="underline cursor-pointer text-gray-900" data-route="/bestellijst">Bestelling afronden</p>`
        });
      }
    },
    // Function to add product to the cart
    order(productId, count) {
      let order = this.baseProductDetail;
      if (order) {
        let isInsuredProd =
          this.baseProductDetail.products.filter((x) => x.productId === productId && x.isInsured === true).length > 0;
        let isConsignmentProduct =
          this.baseProductDetail.products.filter((x) => x.productId === productId && x.isConsignmentProduct === true)
            .length > 0;
        if (!isInsuredProd && !this.isReplenishmentFlow) {
          this.isPrompt = true;
          this.currentOrderDetails = {
            productId: productId,
            amount: count,
            isConsignmentProduct: isConsignmentProduct
          };
        } else {
          this.isPrompt = false;
          order.isInsured = isInsuredProd;
          order.addedToBasket = true;
          order.count = this.count;
          addToShoppingCart(this.shoppingCart, productId, count, this.activePpwRecId, isConsignmentProduct);
          this.showAlert(productId);
        }
      }
    },
    continueAddProduct() {
      this.isPrompt = false;
      addToShoppingCart(
        this.shoppingCart,
        this.currentOrderDetails.productId,
        this.currentOrderDetails.amount,
        this.activePpwRecId,
        this.currentOrderDetails.isConsignmentProduct
      );
      this.showAlert(this.currentOrderDetails.productId);
      this.currentOrderDetails = {};
    },
    closeOverlay() {
      this.isPrompt = false;
    },
    computeBaseProductDetails() {
      this.$emit('favouriteSuccess');
    },
    getEnumValue(enumList, enumKey) {
      if (enumKey === 'null' || enumKey === '') {
        return enumList.false;
      }
      for (const key in enumList) {
        if (enumList.hasOwnProperty(key)) {
          if (key === enumKey) {
            return enumList[key];
          }
        }
      }
    },
    goToAlternativesProductDetailsPage(baseProductId) {
      if (baseProductId) {
        router.push('/catalog/baseProduct/' + baseProductId);
      }
    },
    favorite(product, baseProduct) {
      const productId = product.productId;

      this.selectedProductForFavorite = product;
      this.selectedBaseProductForFavorite = baseProduct;
      this.favProductId = productId;
      this.showProductFavourites = true;
    },
    closeFavOverlay() {
      this.showProductFavourites = false;
    },
    successSaveFavorite(isAdded) {
      this.selectedProductForFavorite = null;
      this.selectedBaseProductForFavorite = null;
      this.favProductId = null;
      this.closeFavOverlay();
      this.$emit('favouriteSuccess');
    },
    getButtonText(productRelationType) {
      switch (productRelationType) {
        case 'Followup':
          return 'Bekijk opvolgend product';
        case 'Substitute':
          return 'Bekijk vervangend product';
        case 'Alternatives':
          return 'Bekijk alternatieve product';
        default:
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-description {
  > h1 {
    display: flex;
    font-size: 20px;
    color: $teal-darkest;
    align-items: center;
    font-weight: 300;
  }
  strong {
    display: flex;
    align-items: center;
    align-self: flex-start;
    border-bottom: 1px solid $red;
    margin-bottom: 10px;
  }
  > div {
    margin-bottom: 10px;

    > div {
      width: 100%;
    }
  }
  table {
    display: block;
    margin-left: 20px;
    td:first-child {
      font-weight: bold;
    }
    td:last-child {
      padding-left: 10px;
    }
  }
  p {
    margin-left: 20px;
    margin-bottom: 10px;
    margin-top: 0px !important;
  }
  &__v_overlay {
    width: 460px;
  }
  &__noBorder {
    border: none;
    margin: 5px 0px 0px 0px;
  }
  &__dashboard_button {
    width: 220px;
    height: 40px;
    border-radius: 3px;
    background-color: $teal-darkest;
    font-size: 16px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: $white;
  }
  &__continue_button {
    width: 150px;
    height: 30px;
    font-size: 16px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.19;
    letter-spacing: normal;
    text-align: left;
    color: $cyan;
  }
  &__overlay_title {
    font-size: 24px;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: $cyan;
    font-weight: 300;
  }
  &__overlay_text {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: $gray-darkest;
  }
  &__closeOverlay {
    float: right;
    margin: -5px 0px 0px 0px;
    cursor: pointer;
  }
  &__overlay_div {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999999 !important;
  }
  &__overlay_box {
    position: relative;
    z-index: 99999998 !important;
    text-align: left;
    padding: 2rem;
    background: $white;
    width: 100%;
    max-width: 600px;
    box-sizing: border-box;
  }
  &__invisible_div {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &__favorite-icon {
    .material-design-icon {
      display: inline-block;
    }
    fill: $cyan-dark !important;
    align-self: end !important;
  }
}
</style>
